import React, {FC, useState} from "react";
import { withStore } from "../../store";
import { SignInModal, UpgradeModal, TrialProgressModal } from "../../components/Modals";
import { Constants, AuthorizeLiveplayer } from "../../utilities";
import LiveTab from './LiveTab'
import _ from "lodash";
import { StoreProps } from "../../store/types";
import { PageSection } from "../../types";
import "./Live.scss";

type LiveProps = {
  component: PageSection;
  category: string;
  store: StoreProps;
  playLiveVideo: (channel: any) => void;
  enableAbroadBanner: () => void;
};

const Live: FC<LiveProps> = ({
  component,
  playLiveVideo,
  category,
  enableAbroadBanner,
  store: { country, isAbroad },
}) => {
  const contentItems = component.collection.nodes;
  const [showPrompt, setShowPrompt] = useState("");


  const handleLiveClick = async (channel) => {
    channel.extId = channel.houseid
    channel.callSchedule = true;
    channel.title = Constants.LiveChannels.find( ele => ele.toLowerCase() === category.toLowerCase());
    await AuthorizeLiveplayer(
      isAbroad,
      enableAbroadBanner,
      setShowPrompt,
      country,
      channel.title,
      channel,
      playLiveVideo
    );
  }


  return (
    <div className="Live">
      {contentItems && contentItems.map( (item, index) => {
        return <LiveTab key={index} item={item} category={category} handleLiveClick={handleLiveClick} last={contentItems.length === index + 1}></LiveTab>
      } )}
      { showPrompt === Constants.Prompts[0] && <SignInModal onClose={() => {setShowPrompt("")}} />} 
      { showPrompt === Constants.Prompts[2] && <TrialProgressModal onClose={() => {setShowPrompt("")}} /> }
      { showPrompt === Constants.Prompts[1] && <UpgradeModal onClose={() => setShowPrompt("")} /> }
    </div>
  )
}

export default withStore(Live);
